import React, { Component, Fragment } from "react";
import { Button } from "antd";
import "antd/dist/antd.css";
import card from "../../style/images/game/TOURNAMENTS/snake-t.png";
import achivmnt from "../../style/images/game/TOURNAMENTS/achivmnt.png";
import watchnow from "../../style/images/game/TOURNAMENTS/WATCH NOW BTN.png";
import "./singleTournament.css";

export default class TournamentCard extends Component {
  render() {
    return (
      <Fragment>
        <div className="row tournamentCard">
          <div className="col-xs-2">
            <img src={card} />
          </div>
          <div className="col-xs-10">
            <div className="row">
              <div className="col-xs-8">
                <div class="dark-data"> Snake - T18</div>
                <div class="req">25 PLAYERS REQUIRED</div>
              </div>
              <div className="col-xs-4">
                <div className="row">
                  <div className="col-xs-6">
                    <img src={achivmnt} />
                  </div>
                  <div className="col-xs-6" style={{ right: "18%" }}>
                    <span>1200 POINTS</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="row Clist">
              <div className="col-xs-8">
                <div className="row  ">
                  <div className="col-xs-6 ">
                    <div class="live">
                      <ul>
                        <li>LIVE</li>
                        <li>STARTS</li>
                        <li>LEVEL REQUIRED</li>
                        <li>CASH PRIZE</li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <div class="end ">
                      <ul>
                        <li>ENDS IN 45:36</li>
                        <li>01/01/2019</li>
                        <li>LV.23</li>
                        <li style={{ color: "#9da3bf !important" }}>£ 160,00</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-4">
                <div className="">
                  <br />
                  <br />
                  <Button
                    style={{
                      color: "transparent",
                      display: "contents"
                    }}
                    type="image"
                    htmlType="submit"
                  >
                    <img style={{ width: "100%" }} src={watchnow} />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
